export default __webpack_public_path__ + "static/media/ticino.3d6b619d.jpg";